export const nlData = `
  <div class="paragraph">
    <div class="page-title">Veelgestelde vragen over het Trade-In-programma (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">Wie kan deelnemen aan het Trade-In-programma?</div>
    <div class="text-box">
      <div class="text">
        De Trade-In-dienst is beschikbaar voor personen van 18 jaar of ouder die wettig verblijven in een lidstaat van de Europese Unie of in het Verenigd Koninkrijk.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wat moet ik doen voordat ik mijn oude apparaat verzend?</div>
    <div class="text-box">
      <div class="text">
        Voordat u uw apparaat verzendt:<br>
        • Verwijder alle persoonlijke gegevens en eventuele PIN-codes, wachtwoorden of schermvergrendelingen.<br>
        • Voer een volledige fabrieksreset uit.<br>
        • Op iPhone: verbreek uw iCloud-account door "Zoek mijn iPhone" uit te schakelen.<br>
        • Op Android: verwijder uw Google-account (Instellingen > Accounts > Google > Account verwijderen).<br>
        Dit zorgt ervoor dat het apparaat niet meer aan uw account is gekoppeld en beschermt uw persoonlijke informatie.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hoe kan ik mijn oude apparaat verzenden?</div>
    <div class="text-box">
      <div class="text">
        <strong>Verpakking:</strong> gebruik een stevige, ondoorzichtige doos (niet transparant) en voeg interne bescherming toe (zoals noppenfolie) om schade tijdens het transport te voorkomen.<br>
        <strong>Verzendlabel:</strong> als u niet over geschikt verpakkingsmateriaal beschikt, kunt u dit aanvragen bij het afgiftepunt wanneer u het pakket inlevert.<br>
        <strong>Documentatie:</strong> print, vul in en onderteken de Verklaring van Eerlijkheid en plaats deze in het pakket voordat u het verzegelt.<br>
        <strong>Veilige sluiting:</strong> zorg ervoor dat het pakket goed is gesloten en bevestig het gratis verzendlabel op een goed zichtbare plaats.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Welke soorten apparaten worden niet geaccepteerd?</div>
    <div class="text-box">
      <div class="text">
        Wij accepteren geen apparaten die:<br>
        • SIM-vergrendeld zijn bij een provider;<br>
        • niet kunnen worden ingeschakeld of opgeladen;<br>
        • geen verbinding kunnen maken via Bluetooth of Wi-Fi;<br>
        • een intern defect of moederbordprobleem hebben;<br>
        • nog steeds gekoppeld zijn aan iCloud- of Google-accounts;<br>
        • vervalsingen of replica's zijn;<br>
        • ernstig beschadigd zijn.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Moet ik accessoires (oplader, kabel, enz.) meesturen?</div>
    <div class="text-box">
      <div class="text">
        Dat is niet verplicht, maar wordt wel aanbevolen. Het meesturen van accessoires draagt bij aan duurzaamheid en hergebruik.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Moet ik oortelefoons meesturen?</div>
    <div class="text-box">
      <div class="text">
        Nee. Om hygiënische redenen worden oortelefoons weggegooid en niet meegenomen in de beoordeling.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Moet ik de aankoopfactuur meesturen?</div>
    <div class="text-box">
      <div class="text">
        Nee, de factuur is niet vereist voor de beoordeling of betaling. U kunt deze bewaren voor uw eigen administratie.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hoe wordt mijn oude apparaat beoordeeld?</div>
    <div class="text-box">
      <div class="text">
        Wij gebruiken gecertificeerde diagnosesoftware en voeren een handmatige inspectie uit in ons beoordelingscentrum om de staat van uw apparaat te bepalen. Alle beoordelings- en gegevensverwerkingsprocedures worden uitgevoerd in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG – EU 2016/679), waarmee de veiligheid en vertrouwelijkheid van uw gegevens wordt gewaarborgd.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wat gebeurt er als de door mij opgegeven staat niet overeenkomt met jullie beoordeling?</div>
    <div class="text-box">
      <div class="text">
        Als er verschillen zijn tussen de opgegeven staat en onze beoordeling, ontvangt u een e-mail met:<br>
        • <strong>Een bijgewerkt aanbod</strong> op basis van de daadwerkelijke inspectie.<br>
        • <strong>Het diagnoserapport</strong> en de redenen voor het verschil.<br><br>
        U kunt ervoor kiezen om het aanbod te accepteren of te weigeren:<br>
        • Als u accepteert, wordt het Trade-In-proces afgerond en ontvangt u de betaling op uw bankrekening binnen 3 werkdagen.<br>
        • Als u weigert, is het retourproces afhankelijk van uw locatie:<br>
        &nbsp;&nbsp;• Voor klanten in Spanje: de retourzending wordt kosteloos geregeld en betaald door Danghuan Europe S.L.<br>
        &nbsp;&nbsp;• Voor klanten buiten Spanje: er geldt een retourtarief van maximaal 22 EUR / 19 GBP / 165 DKK / 245 SEK (incl. btw).<br>
        &nbsp;&nbsp;• Het tarief moet binnen 5 kalenderdagen na ontvangst van het betalingsverzoek worden voldaan via het officiële voorafbetaalde retourlabel dat door Danghuan wordt verstrekt.<br>
        &nbsp;&nbsp;• Betalingsgegevens worden op verzoek verstrekt of zijn opgenomen in de e-mail met de betalingslink.<br>
        &nbsp;&nbsp;• Zodra de betaling (indien van toepassing) is bevestigd, controleert Danghuan de transactie binnen 5 werkdagen en regelt de retourzending naar uw oorspronkelijke adres. U wordt per e-mail op de hoogte gebracht zodra de verzending heeft plaatsgevonden, inclusief de bijbehorende trackinginformatie.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wat gebeurt er als ik niet reageer op het bijgewerkte aanbod?</div>
    <div class="text-box">
      <div class="text">
        Als er binnen 30 kalenderdagen na de kennisgeving geen antwoord wordt ontvangen, wordt het herziene aanbod automatisch als geweigerd beschouwd.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wat gebeurt er met mijn persoonlijke gegevens?</div>
    <div class="text-box">
      <div class="text">
        U moet alle gegevens verwijderen voordat u uw oude apparaat verzendt. Als wij nog resterende gegevens ontdekken, zullen wij het proces pauzeren en contact met u opnemen om deze te verwijderen. Wij voldoen volledig aan de AVG (EU-Verordening 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wie betaalt de verzendkosten?</div>
    <div class="text-box">
      <div class="text">
        De eerste verzending is altijd gratis.<br><br>
        Als u het bijgewerkte aanbod weigert:<br>
        • Voor klanten in Spanje: de retourzending wordt kosteloos geregeld en betaald door Danghuan Europe S.L.<br>
        • Voor klanten buiten Spanje: er geldt een retourtarief van maximaal 22 EUR / 19 GBP / 165 DKK / 245 SEK (incl. btw).<br>
        • Het tarief moet binnen 5 kalenderdagen na ontvangst van het betalingsverzoek worden voldaan via het officiële voorafbetaalde retourlabel dat door Danghuan wordt verstrekt.<br>
        • Betalingsgegevens worden op verzoek verstrekt of zijn opgenomen in de e-mail met de betalingslink.<br>
        • Zodra de betaling (indien van toepassing) is bevestigd, controleert Danghuan de transactie binnen 5 werkdagen en regelt de retourzending naar uw oorspronkelijke adres. U ontvangt een e-mailmelding zodra het pakket is verzonden, inclusief trackinginformatie.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wat gebeurt er als mijn pakket verloren gaat tijdens de verzending?</div>
    <div class="text-box">
      <div class="text">
        Als uw apparaat tijdens het transport verloren gaat, zal Danghuan Europe S.L. u helpen met de officiële claimprocedure bij de koerier.<br><br>
        Een zending wordt als verloren beschouwd als deze niet is gevolgd, bevestigd of ontvangen door Danghuan binnen 15 kalenderdagen na overhandiging aan de vervoerder.<br><br>
        • U moet het door Danghuan verstrekte officiële voorafbetaalde verzendlabel gebruiken; elk ander verzendmiddel maakt de dekking tegen verlies ongeldig.<br>
        • Claims bij UPS moeten binnen 60 dagen na aanmaak van het label worden ingediend.<br>
        • Voor CORREOS (Spanje) moeten claims zo snel mogelijk worden ingediend, bij voorkeur binnen 15 dagen en uiterlijk binnen 1 jaar na de verzenddatum.<br>
        • Danghuan zal helpen bij het onderzoek van de vervoerder, dat doorgaans 30–60 dagen duurt.<br><br>
        Als het verlies wordt bevestigd in het logistieke systeem van Danghuan en het officiële label werd gebruikt, zal de vergoeding niet hoger zijn dan de definitieve geschatte Trade-In-waarde van het apparaat.<br><br>
        Goedgekeurde betalingen worden rechtstreeks overgemaakt naar het IBAN dat bij de registratie is opgegeven.<br><br>
        <em>Opmerking: elke vergoeding is afhankelijk van het beleid van de betreffende koerier.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Wanneer ontvang ik de betaling?</div>
    <div class="text-box">
      <div class="text">
        Zodra het definitieve aanbod is geaccepteerd, wordt de betaling via bankoverschrijving uitgevoerd binnen 3 werkdagen. Zorg ervoor dat uw IBAN en uw persoonlijk identificatienummer correct zijn en overeenkomen met de rekeninghouder.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Is het verplicht om mijn persoonlijk identificatienummer op te geven?</div>
    <div class="text-box">
      <div class="text">
        Ja. Om de betaling te verwerken, moet u een geldig persoonlijk identificatienummer opgeven, zonder spaties of speciale tekens, dat overeenkomt met de IBAN-rekeninghouder.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kan ik mijn Trade-In-transactie annuleren?</div>
    <div class="text-box">
      <div class="text">
        Ja, zolang uw oude apparaat nog niet is betaald. Neem zo snel mogelijk contact met ons op via <a href="mailto:insta360@danghuan.eu">insta360@danghuan.eu</a>. Als u uw apparaat al hebt verzonden, neem dan binnen 48 uur contact met ons op; anders verloopt het recyclingproces normaal.
      </div>
    </div>
  </div>
`;